import type { AllRouteEndpoints } from "../routeTypes";
export const commentsTargetNotificationSetting = "/comments/:target/notification_setting";

export const commentsTargetNotificationSettingCacheKeys: AllRouteEndpoints[] = [commentsTargetNotificationSetting];
